module.exports = digitalDataProxy;